import * as React from "react";
import Modal from "@mui/material/Modal";
import Icons from "../../../assets/icons";
import styled from "./ProductDetail.module.css";
import callApi from "../../../services/api/apiClient";
import { useSelector } from "react-redux";

export default function ProductDetail({ isOpen, onClose, id }) {
  console.log("HELLLLLOIDDD", id);
  const [detail, setDetail] = React.useState(null);

  React.useEffect(() => {
    callApi(`product/detail`)
      .loadingGroup("productDetail")
      .withKeyParameter({ productID: id })
      .execute()
      .then((res) => {
        setDetail(res);
      });
  }, [id]);

  console.log("HHHHH", detail);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="flex items-center justify-center"
    >
      <div className={styled.detail_container}>
        <p className={styled.title}>Product Detail</p>
        <div className={styled.form_image}>
          {detail?.image ? (
            <img
              src={detail?.image}
              alt=""
              className="w-full h-full object-cover"
            />
          ) : (
            <img
              src={Icons.defaultImage}
              alt=""
              className="w-[168px] h-[144px]"
            />
          )}
        </div>
        <div className={styled.customer_detail}>
          <div className={styled.row_container}>
            <label className="text-lg font-interSemiBold text-black-0">
              Code : {detail?.lot_no}
            </label>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Type : </label>
            <p className={styled.value}>
              {detail?.type?.name ? detail?.type?.name : "-"}
            </p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Price :</label>
            <p className={styled.value}>
              {detail?.price ? detail?.price : "-"}
            </p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Live Sale Price :</label>
            <p className={styled.value}>
              {detail?.live_sale?.price ? detail?.live_sale?.price : "-"}
            </p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Live Sale Code :</label>
            <p className={styled.value}>
              {detail?.live_sale?.code ? detail?.live_sale?.code : "-"}
            </p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Quantity : </label>
            <p className={styled.value}>
              {detail?.product_qty ? detail?.product_qty : "-"}
            </p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>No. of Item</label>
            <p className={styled.value}>
              {detail?.no_of_item ? detail?.no_of_item : "-"}
            </p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Current Location:</label>
            <p className={styled.value}>{detail?.warehouse_location?.name}</p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Package :</label>
            <p className={styled.value}>
              {detail?.package?.name ? detail?.package?.name : "-"}
            </p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Sale Order :</label>
            <p className={styled.value}>
              {detail?.sale_order?.name ? detail?.sale_order?.name : "-"}
            </p>
          </div>
          <div className={styled.row_container}>
            <label className={styled.label}>Note:</label>
            <p className={styled.value}>{detail?.note ? detail?.note : "-"}</p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
